module.exports = __webpack_public_path__ + "media/images/logos/youtube-384b3dc2b9d0eeaefc4948db4da70ed2.svg";